import React, { useMemo } from 'react'
import Box from '@cloudscape-design/components/box'
import { getToolUrl } from '@services/ToolMenuConfigService'
import { useBundle } from '@amzn/react-arb-tools'
import { BUNDLE_NAME } from '@src/constants'
import { t } from '@src/translationHelper'
import './CatalogView.scss'

/**
 * CatalogView — embeds the Catalog page (JWOStoreManagementCatalogWebsite) as an iframe filling
 * the tab panel. Mirrors OrdersView.
 *
 * CATALOG_ASSET_ID must equal ASSET_ID in JwoCatalogTool.constants.ts
 * (JWOStoreManagementPlatformRegistration) and the TOOL_ID the website passes to
 * PlatformClient.init; CATALOG_DISPLAY_NAME must equal its registered display name, because
 * getToolUrl resolves the URL from it. Locally the URL is overridden to the catalog dev server
 * via local.dev.config.ts toolOverrides.
 */
export const CATALOG_DISPLAY_NAME = 'Catalog'
export const CATALOG_ASSET_ID = 'jwo-catalog-app'

/** The registered URL with any hash removed; the Catalog page has no hash route. '' if unresolved. */
export const buildCatalogUrl = (): string => {
    const base = getToolUrl(CATALOG_DISPLAY_NAME, CATALOG_ASSET_ID)
    if (!base) {
        console.warn('OperationsPage: could not resolve Catalog URL')
        return ''
    }
    const hashIndex = base.indexOf('#')
    return hashIndex !== -1 ? base.substring(0, hashIndex) : base
}

const CatalogView: React.FC = () => {
    const [bundle] = useBundle(BUNDLE_NAME)
    const catalogUrl = useMemo(() => buildCatalogUrl(), [])

    if (!catalogUrl) {
        return (
            <Box padding="l" color="text-status-inactive">
                {t(bundle, 'jsma-web-operations-catalogUnavailable')}
            </Box>
        )
    }

    return (
        <div className="operations-catalog-container" data-atb-id="operations-catalog-container">
            <iframe
                className="operations-catalog-frame"
                data-atb-id="operations-catalog-frame"
                title={t(bundle, 'jsma-web-operations-catalogTitle')}
                aria-label={t(bundle, 'jsma-web-operations-catalogTitle')}
                src={catalogUrl}
            />
        </div>
    )
}

export default CatalogView
